// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Mulish-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/Mulish-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/Mulish-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/fonts/Mulish-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/background/bigLeaf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/img/heroBanner.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Primary_color: #288f43;
  --Lime_Green: #76b95f;
  --Notification_Green: #f1fff4;
  --Secondary: #8a92a6;
  --Light_Green: #d6ffdd;
  --Text_Color: #8a92a6;
  --Background: #fffcf8;
  --Table_Header: #ddebba;
  --Table_Data: #effff2;
  --Placeholder: #cdcfd3;
  --Support_Blue: #007aff;
  --Support_Orange: rgba(255, 168, 68, 1);
  --Table_Data: rgba(239, 255, 242, 1);
  --Medium_Light_Green: rgba(214, 255, 221, 1);
}

/* body Custom scrollbar styling */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #f5fce2;
  border-radius: 10px;
  border: 2px solid #c1d68e;
}

::-webkit-scrollbar-track {
  background: var(--base_light-yellow);
  border-radius: 10px;
}

@font-face {
  font-family: "Mulish";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  /* Regular weight */
  font-weight: 400;
}

@font-face {
  font-family: "Mulish";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  /* Bold weight */
  font-weight: 700;
}

@font-face {
  font-family: "Mulish";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  /* Light weight */
  font-weight: 300;
}

@font-face {
  font-family: "Mulish";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 600;
}

/* Apply the font globally */
* {
  padding: 0;
  margin: 0;
  font-family: "Mulish", sans-serif !important;
  box-sizing: border-box;
}
label {
  color: #8a92a6 !important;

  margin: 0 0 5px;
}
.cursor_pointer {
  cursor: pointer;
}

/* --------------------Color Classes---------------- */

.text_primary {
  color: var(--Primary_color) !important;
}

.text_lime_green {
  color: var(--Lime_Green) !important;
}

.text_secondary {
  color: var(--Secondary) !important;
}

.text_light_green {
  color: var(--Light_Green) !important;
}
.text_support_Blue {
  color: var(--Support_Blue) !important;
}
.text_Support_Orange {
  color: var(--Support_Orange) !important;
}

.text_color-lable {
  color: var(--Text_Color) !important;
}

.text_background {
  color: var(--Background) !important;
}

.font-weight_600 {
  font-weight: 600;
}

/* ----------------------Background Colors ---------------------- */

.bg_primary {
  background-color: var(--Primary_color) !important;
}

.bg_lime_green {
  background-color: var(--Lime_Green) !important;
}

.bg-secondary {
  background-color: var(--Secondary) !important;
}

.bg_light_green {
  background-color: var(--Light_Green) !important;
}
.bg_light_gray {
  background-color: #ececec !important;
}

.bg_text {
  background-color: var(--Text_Color) !important;
}

.bg_background {
  background-color: var(--Background) !important;
}

.bg_Table_Header {
  background-color: var(--Table_Header) !important;
}
.Table_Data {
  background-color: var(--Table_Data) !important;
}

.bg_support_orange {
  background-color: var(--Support_Orange) !important;
}

.bg_medium_light_green {
  background-color: var(--Medium_Light_Green);
}
.bg_Notification_Green {
  background-color: var(--Notification_Green);
}

/* -------------- Shadows --------------------------------------- */

.common_shadow {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.big_Shadow {
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.25);
}
/* ---------------------------- width classes -------------------------------- */
.max_width_75 {
  max-width: 75%;
}

.z_index_1 {
  z-index: 1;
}
/*------------------------------ Scroolbar Css------------------------------- */

/* Custom scrollbar styling */
.transparant_Scrollbar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.transparant_Scrollbar::-webkit-scrollbar-thumb {
  background-color: #f5fce2;
  border-radius: 10px;
  border: 2px solid #c1d68e;
}

.transparant_Scrollbar::-webkit-scrollbar-track {
  background: var(--base_light-yellow);
  border-radius: 10px;
}

.custom-spinner {
  width: 24px;
  height: 24px;
  border-width: 3px;
  border-color: var(--Lime_Green);
  border-right-color: transparent;
}

/* ---------------------------- Layout Css ------------------------------------ */

.layoutMainWrapper {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.layoutOutletWrapper,
.layoutOutletWrapperClose {
  transition: all 0.5s ease-in-out;
}

.outlateWrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
}

.layoutOutletWrapper {
  width: 78vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.layoutOutletWrapperClose {
  width: 92vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  /* margin-left: 80px; */
}

.heroBannerWrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 100%;
  height: 180px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  margin-left: -6;
  margin-top: -60px;
}

.heroBannerWrapper > h3 {
  position: absolute;
  left: 20px;
  bottom: 40px;
  font-weight: 800;
  font-size: 30px;
}

.heroBannerWrapper > div {
  display: flex;
  position: absolute;
  right: 10px;
  top: 70px;
  cursor: pointer;
}

/* --------------------table css ----------------------*/

.tablemain {
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
  height: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

/* Custom scrollbar styling */
.tablemain::-webkit-scrollbar,
.departmentNavButtons::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.tablemain::-webkit-scrollbar-thumb,
.departmentNavButtons::-webkit-scrollbar-thumb {
  background-color: #f5fce2;
  border-radius: 10px;
  border: 2px solid #c1d68e;
}

.tablemain::-webkit-scrollbar-track,
.departmentNavButtons::-webkit-scrollbar-track {
  background: var(--base_light-yellow);
  border-radius: 10px;
}

.tableWrapper {
  background-color: #fff;
  border-radius: 8px;
}

table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

table td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.row-fix-to-last {
  position: sticky;
  right: 0px;
  background-color: #f9feef;
}

.table-th-bg-color {
  background-color: #ddebba;
  z-index: 12;
}

.col_100px {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_150px {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_200px {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_250px {
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_300px {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_350px {
  width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col_400px {
  width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

table tbody tr:first-child td {
  border: none !important;
}

table thead tr th {
  white-space: nowrap !important;
}

.search_btn_wrapper {
  height: 12%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding-bottom: 20px;
}

.search_btn_wrapper .buttons_wrapper {
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
}
.DataNotFoundText {
  text-align: center;
  margin-top: 40px;
  color: var(--Text_Color);
}

.input_lable {
  margin-bottom: 5px;
  color: #8a92a6 !important;
}

.css-13cymwt-control {
  border: 1px solid #8a92a6 !important;
  border-radius: 4px;
  padding: 2px 0px;
}
.css-1xc3v61-indicatorContainer {
  color: #8a92a6 !important ;
}
.css-t3ipsp-control {
  padding: 2px 0px !important;
  border-color: var(--Primary_color) !important;
  box-shadow: rgba(40, 143, 67, 0.3) 0px 2px 8px 0px;
}

.css-1nmdiq5-menu {
  z-index: 11111 !important;
}

.InputWithLabel .input:focus {
  border-color: var(--Primary_color) !important;
  box-shadow: rgba(40, 143, 67, 0.3) 0px 2px 8px 0px;
}

.label {
  margin-bottom: 5px !important;
  color: #8a92a6 !important;
}

.AttachmentImage {
  width: 450px !important;
  height: 400px !important;
  object-fit: contain;
}

.greenSubHeading {
  color: var(--Primary_color);
  font-size: 20px;
  margin: 0px;
}

/* ------------------------ Media Query ---------------------- */

@media (max-width: 1200px) {
  .layoutOutletWrapper {
    width: 74vw;
  }
}
@media (max-width: 1000px) {
  .layoutOutletWrapper {
    width: 100vw;
  }
}

@media (max-width: 800px) {
  .sidebarMinWrapperClose > div {
    width: 12vw;
  }

  .layoutOutletWrapperClose {
    width: 88vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+DAA+D;EAC/D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAA4D;EAC5D,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAA6D;EAC7D,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+DAAgE;EAChE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,SAAS;EACT,4CAA4C;EAC5C,sBAAsB;AACxB;AACA;EACE,yBAAyB;;EAEzB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,sDAAsD;;AAEtD;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mEAAmE;;AAEnE;EACE,iDAAiD;AACnD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA,mEAAmE;;AAEnE;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;AACA,gFAAgF;AAChF;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA,+EAA+E;;AAE/E,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,yDAAwD;EACxD,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yDAAoD;EACpD,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA,wDAAwD;;AAExD;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA,gEAAgE;;AAEhE;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[":root {\n  --Primary_color: #288f43;\n  --Lime_Green: #76b95f;\n  --Notification_Green: #f1fff4;\n  --Secondary: #8a92a6;\n  --Light_Green: #d6ffdd;\n  --Text_Color: #8a92a6;\n  --Background: #fffcf8;\n  --Table_Header: #ddebba;\n  --Table_Data: #effff2;\n  --Placeholder: #cdcfd3;\n  --Support_Blue: #007aff;\n  --Support_Orange: rgba(255, 168, 68, 1);\n  --Table_Data: rgba(239, 255, 242, 1);\n  --Medium_Light_Green: rgba(214, 255, 221, 1);\n}\n\n/* body Custom scrollbar styling */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #f5fce2;\n  border-radius: 10px;\n  border: 2px solid #c1d68e;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--base_light-yellow);\n  border-radius: 10px;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src: url(\"/public/fonts/Mulish-Regular.ttf\") format(\"truetype\");\n  /* Regular weight */\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src: url(\"/public/fonts/Mulish-Bold.ttf\") format(\"truetype\");\n  /* Bold weight */\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src: url(\"/public/fonts/Mulish-Light.ttf\") format(\"truetype\");\n  /* Light weight */\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src: url(\"/public/fonts/Mulish-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n}\n\n/* Apply the font globally */\n* {\n  padding: 0;\n  margin: 0;\n  font-family: \"Mulish\", sans-serif !important;\n  box-sizing: border-box;\n}\nlabel {\n  color: #8a92a6 !important;\n\n  margin: 0 0 5px;\n}\n.cursor_pointer {\n  cursor: pointer;\n}\n\n/* --------------------Color Classes---------------- */\n\n.text_primary {\n  color: var(--Primary_color) !important;\n}\n\n.text_lime_green {\n  color: var(--Lime_Green) !important;\n}\n\n.text_secondary {\n  color: var(--Secondary) !important;\n}\n\n.text_light_green {\n  color: var(--Light_Green) !important;\n}\n.text_support_Blue {\n  color: var(--Support_Blue) !important;\n}\n.text_Support_Orange {\n  color: var(--Support_Orange) !important;\n}\n\n.text_color-lable {\n  color: var(--Text_Color) !important;\n}\n\n.text_background {\n  color: var(--Background) !important;\n}\n\n.font-weight_600 {\n  font-weight: 600;\n}\n\n/* ----------------------Background Colors ---------------------- */\n\n.bg_primary {\n  background-color: var(--Primary_color) !important;\n}\n\n.bg_lime_green {\n  background-color: var(--Lime_Green) !important;\n}\n\n.bg-secondary {\n  background-color: var(--Secondary) !important;\n}\n\n.bg_light_green {\n  background-color: var(--Light_Green) !important;\n}\n.bg_light_gray {\n  background-color: #ececec !important;\n}\n\n.bg_text {\n  background-color: var(--Text_Color) !important;\n}\n\n.bg_background {\n  background-color: var(--Background) !important;\n}\n\n.bg_Table_Header {\n  background-color: var(--Table_Header) !important;\n}\n.Table_Data {\n  background-color: var(--Table_Data) !important;\n}\n\n.bg_support_orange {\n  background-color: var(--Support_Orange) !important;\n}\n\n.bg_medium_light_green {\n  background-color: var(--Medium_Light_Green);\n}\n.bg_Notification_Green {\n  background-color: var(--Notification_Green);\n}\n\n/* -------------- Shadows --------------------------------------- */\n\n.common_shadow {\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n}\n\n.big_Shadow {\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.25);\n}\n/* ---------------------------- width classes -------------------------------- */\n.max_width_75 {\n  max-width: 75%;\n}\n\n.z_index_1 {\n  z-index: 1;\n}\n/*------------------------------ Scroolbar Css------------------------------- */\n\n/* Custom scrollbar styling */\n.transparant_Scrollbar::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.transparant_Scrollbar::-webkit-scrollbar-thumb {\n  background-color: #f5fce2;\n  border-radius: 10px;\n  border: 2px solid #c1d68e;\n}\n\n.transparant_Scrollbar::-webkit-scrollbar-track {\n  background: var(--base_light-yellow);\n  border-radius: 10px;\n}\n\n.custom-spinner {\n  width: 24px;\n  height: 24px;\n  border-width: 3px;\n  border-color: var(--Lime_Green);\n  border-right-color: transparent;\n}\n\n/* ---------------------------- Layout Css ------------------------------------ */\n\n.layoutMainWrapper {\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.layoutOutletWrapper,\n.layoutOutletWrapperClose {\n  transition: all 0.5s ease-in-out;\n}\n\n.outlateWrapper {\n  background-image: url(\"./assets/background/bigLeaf.svg\");\n  background-repeat: no-repeat;\n}\n\n.layoutOutletWrapper {\n  width: 78vw;\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.layoutOutletWrapperClose {\n  width: 92vw;\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* margin-left: 80px; */\n}\n\n.heroBannerWrapper {\n  background-image: url(\"./assets/img/heroBanner.svg\");\n  width: 100%;\n  height: 180px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n  margin-left: -6;\n  margin-top: -60px;\n}\n\n.heroBannerWrapper > h3 {\n  position: absolute;\n  left: 20px;\n  bottom: 40px;\n  font-weight: 800;\n  font-size: 30px;\n}\n\n.heroBannerWrapper > div {\n  display: flex;\n  position: absolute;\n  right: 10px;\n  top: 70px;\n  cursor: pointer;\n}\n\n/* --------------------table css ----------------------*/\n\n.tablemain {\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: auto;\n  height: 100%;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n/* Custom scrollbar styling */\n.tablemain::-webkit-scrollbar,\n.departmentNavButtons::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.tablemain::-webkit-scrollbar-thumb,\n.departmentNavButtons::-webkit-scrollbar-thumb {\n  background-color: #f5fce2;\n  border-radius: 10px;\n  border: 2px solid #c1d68e;\n}\n\n.tablemain::-webkit-scrollbar-track,\n.departmentNavButtons::-webkit-scrollbar-track {\n  background: var(--base_light-yellow);\n  border-radius: 10px;\n}\n\n.tableWrapper {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\ntable {\n  table-layout: fixed;\n  width: 100%;\n  border-collapse: collapse;\n}\n\ntable td {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.row-fix-to-last {\n  position: sticky;\n  right: 0px;\n  background-color: #f9feef;\n}\n\n.table-th-bg-color {\n  background-color: #ddebba;\n  z-index: 12;\n}\n\n.col_100px {\n  width: 100px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_150px {\n  width: 150px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_200px {\n  width: 200px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_250px {\n  width: 250px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_300px {\n  width: 300px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_350px {\n  width: 350px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.col_400px {\n  width: 400px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\ntable tbody tr:first-child td {\n  border: none !important;\n}\n\ntable thead tr th {\n  white-space: nowrap !important;\n}\n\n.search_btn_wrapper {\n  height: 12%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  padding-bottom: 20px;\n}\n\n.search_btn_wrapper .buttons_wrapper {\n  display: flex;\n  gap: 0.5rem;\n  margin-left: auto;\n}\n.DataNotFoundText {\n  text-align: center;\n  margin-top: 40px;\n  color: var(--Text_Color);\n}\n\n.input_lable {\n  margin-bottom: 5px;\n  color: #8a92a6 !important;\n}\n\n.css-13cymwt-control {\n  border: 1px solid #8a92a6 !important;\n  border-radius: 4px;\n  padding: 2px 0px;\n}\n.css-1xc3v61-indicatorContainer {\n  color: #8a92a6 !important ;\n}\n.css-t3ipsp-control {\n  padding: 2px 0px !important;\n  border-color: var(--Primary_color) !important;\n  box-shadow: rgba(40, 143, 67, 0.3) 0px 2px 8px 0px;\n}\n\n.css-1nmdiq5-menu {\n  z-index: 11111 !important;\n}\n\n.InputWithLabel .input:focus {\n  border-color: var(--Primary_color) !important;\n  box-shadow: rgba(40, 143, 67, 0.3) 0px 2px 8px 0px;\n}\n\n.label {\n  margin-bottom: 5px !important;\n  color: #8a92a6 !important;\n}\n\n.AttachmentImage {\n  width: 450px !important;\n  height: 400px !important;\n  object-fit: contain;\n}\n\n.greenSubHeading {\n  color: var(--Primary_color);\n  font-size: 20px;\n  margin: 0px;\n}\n\n/* ------------------------ Media Query ---------------------- */\n\n@media (max-width: 1200px) {\n  .layoutOutletWrapper {\n    width: 74vw;\n  }\n}\n@media (max-width: 1000px) {\n  .layoutOutletWrapper {\n    width: 100vw;\n  }\n}\n\n@media (max-width: 800px) {\n  .sidebarMinWrapperClose > div {\n    width: 12vw;\n  }\n\n  .layoutOutletWrapperClose {\n    width: 88vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
